module.exports = __webpack_public_path__ + "media/post-listing-cross-promotoe-ico-2@2x.ab154091.png";